import { render, staticRenderFns } from "./Sidenav1.vue?vue&type=template&id=2fded699&scoped=true&"
import script from "./Sidenav1.vue?vue&type=script&lang=js&"
export * from "./Sidenav1.vue?vue&type=script&lang=js&"
import style0 from "./Sidenav1.vue?vue&type=style&index=0&id=2fded699&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fded699",
  null
  
)

export default component.exports